// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const generativeAiAgentModel = objectOf({
  name: string,
  model: string,
});

export const generativeAiAgentProvider = objectOf({
  code: number,
  name: string,
  models: arrayOf(generativeAiAgentModel),
});

export const isGenerativeAiAgentsModelsResult = objectOf({
  results: arrayOf(generativeAiAgentProvider),
});
